import { BaseModel } from './base-model';

export class MeterPreviewModel implements BaseModel {
  public name?: string;
  public uniq_id?: string;
  public address?: string;
  public units?: string;
  public dt_start?: string;
  public value_start?: number;
  public dt_end?: string;
  public value_end?: number;
  public value_dif?: number;

  init() {}
}
